import { render, staticRenderFns } from "./adminCommunity.vue?vue&type=template&id=d57f9fe6&scoped=true"
import script from "./adminCommunity.vue?vue&type=script&lang=js"
export * from "./adminCommunity.vue?vue&type=script&lang=js"
import style0 from "./adminCommunity.vue?vue&type=style&index=0&id=d57f9fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57f9fe6",
  null
  
)

export default component.exports